module.exports = __webpack_public_path__ + "ionicons.24712f6c47821394fba7.ttf";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/fonts/ionicons.ttf?v=2.0.0
// module id = ../../../../../src/assets/fonts/ionicons.ttf?v=2.0.0
// module chunks = styles